const Filter = () => {
  return (
    <div className="flex relative" style={{ flex: 1 }}>
      <input type="text" placeholder="Search for keywords" className="w-full pr-16 input input-bordered border-inputBorder outline-none focus:ring-0 focus:outline-none focus:border-red-600" />
      <button className="absolute top-0 right-0 rounded-l-none btn border-l-0 border-transparent bg-transparent hover:bg-transparent hover:border-transparent"><i className="fas fa-search text-gray-800"></i></button>
    </div>
  );
}

export default Filter;